'use client';

import { motion, AnimatePresence } from 'framer-motion';
import { usePathname } from 'next/navigation';
import useGeneralStore from '@/store/general';
import { FrozenRouter } from './FrozenRouter';


export const variants = {
  hidden: { opacity: 0, y: 500 },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      style: "easeInOut", duration: 0.75,
    },
  },
  exit: {
    opacity: 1,
    y: -500,
    transition: {
      style: "easeInOut", duration: 0.75,
    },
  },
};

export const variants2 = {
  hidden: { opacity: 0, x: 500, y: 0 },
  enter: {
    opacity: 1,
    x: 0,
    y: 0,
    transition: {
      style: "easeInOut", duration: 0.75,
    },
  },
  exit: {
    opacity: 1,
    x: -500,
    y: 0,
    transition: {
      style: "easeInOut", duration: 0.75,
    },
  },
};

const QuestionTransitionEffect = ({ children }: { children: React.ReactNode }) => {
  // The `key` is tied to the url using the `usePathname` hook.
  const key = usePathname();


  const { isMobile } = useGeneralStore();

  // Choose the appropriate variant based on screen size
  const selectedVariants = isMobile ? variants2 : variants;
  return (
    <AnimatePresence mode="popLayout" initial={false}>
      <motion.div
        key={key}
        initial='false'
        animate="enter"
        exit="exit"
        variants={selectedVariants}
      >
        <FrozenRouter>
          {children}
        </FrozenRouter>
      </motion.div>
    </AnimatePresence>
  );
};

export default QuestionTransitionEffect;
